import React from 'react';
import { styled } from '@mui/material/styles';
import { usePronunciationContext } from '@src/contexts/PronunciationCheckContext';
import { ENTITY_TYPE } from '@src/constants/pronunciationCheck';

const StyledHighlightWord = styled('span')`
  background-color: rgba(0, 122, 255, 0.08);
  border-bottom: 2px dotted #007aff;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: rgba(0, 122, 255, 0.16);
  }

  &.active {
    background-color: rgba(0, 122, 255, 0.32);
  }
`;

const StyledFixedWord = styled('span')`
  background-color: rgba(52, 199, 89, 0.08);
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: rgba(52, 199, 89, 0.16);
  }

  &.active {
    background-color: rgba(52, 199, 89, 0.48);
  }
`;

const InteractiveWord = ({ children, entityKey, StyledComponent }) => {
  const { selectByEntityKey, currentEntityKey } = usePronunciationContext();
  const isActive = currentEntityKey === entityKey;

  const handleMouseDown = (e) => {
    e.stopPropagation();
    selectByEntityKey(entityKey);
  };

  return (
    <StyledComponent
      className={isActive ? 'active' : undefined}
      data-entity-key={entityKey}
      onMouseDown={handleMouseDown}
      role="button"
      tabIndex={-1}
    >
      {children}
    </StyledComponent>
  );
};

const HighlightWord = ({ children, entityKey }) => (
  <InteractiveWord entityKey={entityKey} StyledComponent={StyledHighlightWord}>
    {children}
  </InteractiveWord>
);

const FixedWord = ({ children, entityKey }) => (
  <InteractiveWord entityKey={entityKey} StyledComponent={StyledFixedWord}>
    {children}
  </InteractiveWord>
);

const highlightStrategy = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    if (!entityKey) return false;
    const entity = contentState.getEntity(entityKey);
    return entity.getType() === ENTITY_TYPE.HIGHLIGHT;
  }, callback);
};

const fixedWordStrategy = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    if (!entityKey) return false;
    const entity = contentState.getEntity(entityKey);
    return entity.getType() === ENTITY_TYPE.FIXED_WORD;
  }, callback);
};

export { HighlightWord, FixedWord, highlightStrategy, fixedWordStrategy };
